export default null;

export const LIST_OF_DAYS = ['일', '월', '화', '수', '목', '금', '토'];

export const DAY_OF_THE_WEEK = {
	Monday: '월요일',
	Tuesday: '화요일',
	Wednesday: '수요일',
	Thursday: '목요일',
	Friday: '금요일',
	Saturday: '토요일',
	Sunday: '일요일',
};

// 서버 DB에서 사용하는 생년월일 형식
export const MEMBER_BIRTH_DATE_FORMAT = 'YYYY-MM-DD';

// 회원가입 폼에서 사용하는 생년월일 형식
export const MEMBER_BIRTH_FORM_DATE_FORMAT = 'YYYYMMDD';
